import { render, staticRenderFns } from "./PosStepPayment.vue?vue&type=template&id=3fee90d8"
import script from "./PosStepPayment.vue?vue&type=script&lang=js"
export * from "./PosStepPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports